
<template>
    <div class="h-screen flex w-full bg-img" id="page-recover">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="flex flex-wrap">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block self-center justify-center items-center lg:w-1/2">
                            <img src="@/assets/images/logo/login_banner.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="flex flex-wrap mt-5">
                                    <div class="w-4/5">
                                        <h4 class="mb-4">{{$t('new_password')}}</h4>
                                        <p>
                                            {{$t('new_password_desc')}} <i>My</i> Vila Galé.
                                        </p>
                                        <br>
                                    </div>
                                    <div class="w-1/5">
                                        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer float-right">
                                            <span class="cursor-pointer flex i18n-locale"><img class="w-6 h-6" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" /><span class="hidden sm:block ml-2"></span></span>
                                            <vs-dropdown-menu class="w-50 i18n-dropdown">
                                                <vs-dropdown-item @click="updateLocale('en', false)"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;{{ $t('en') }}</vs-dropdown-item>
                                                <vs-dropdown-item @click="updateLocale('pt', false)"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;{{ $t('pt') }}</vs-dropdown-item>
                                                <vs-dropdown-item @click="updateLocale('br', false)"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/br.png" alt="br" /> &nbsp;{{ $t('br') }}</vs-dropdown-item>
                                                <vs-dropdown-item @click="updateLocale('de', false)"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;{{ $t('de') }}</vs-dropdown-item>
                                                <vs-dropdown-item @click="updateLocale('fr', false)"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;{{ $t('fr') }}</vs-dropdown-item>
                                                <vs-dropdown-item @click="updateLocale('es', false)"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;{{ $t('es') }}</vs-dropdown-item>
                                            </vs-dropdown-menu>
                                        </vs-dropdown>
                                    </div>
                                </div>
                                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder">
                                    <vs-input type="text" class="w-full inline-block" label-placeholder="Password" v-model="password" v-if="show_password" />
                                    <vs-input type="password" class="w-full inline-block" label-placeholder="Password" v-model="password" v-else />
                                    <vs-button 
                                        @click="toggleShow()" 
                                        class="inline-block float-right" 
                                        style="top:-38px; margin-bottom:-38px;" 
                                        color="primary" 
                                        type="flat" 
                                        icon-pack="feather" 
                                        :icon="show_password ? 'icon-eye-off' : 'icon-eye'">
                                    </vs-button>
                                </div>
                                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder pt-2">
                                    <vs-input type="text" class="w-full inline-block" label-placeholder="Confirmar Password" v-model="confirm_password" v-if="show_confirm_password" />
                                    <vs-input type="password" class="w-full inline-block" label-placeholder="Confirmar Password" v-model="confirm_password" v-else />
                                    <vs-button 
                                        @click="toggleShow('confirm')" 
                                        class="inline-block float-right" 
                                        style="top:-38px; margin-bottom:-38px;" 
                                        color="primary" 
                                        type="flat" 
                                        icon-pack="feather" 
                                        :icon="show_confirm_password ? 'icon-eye-off' : 'icon-eye'">
                                    </vs-button>
                                </div>
                                <div class="w-full float-right">    
                                    <vs-button @click="submit_pass()" class="mt-6 mb-6 float-right" color="primary" type="filled">{{$t('submeter')}}</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>

        </div>
    </div>
</template>
<script>
//load configurations on theme
import themeConfig from '@/../themeConfig.js';
// import axios
import axios from 'axios';  
export default {
    data() {
        return {
            password: null,
            confirm_password: null,
            lang: null,
            show_password: false,
            show_confirm_password: false,
        }
    },
    methods: {
        toggleShow(input = 'password') {
            if(input == 'password'){
                this.show_password = !this.show_password;
            }
            if(input == 'confirm'){
                this.show_confirm_password = !this.show_confirm_password;
            }
        },
        submit_pass() {
            if(!this.password){
                this.notify(this.$t('missing_pass'), 'red', 10);
                return false;
            }

            if(!this.confirm_password){
                this.notify(this.$t('missing_conf_pass'), 'red', 10);
                return false;
            }

            if((this.password && this.confirm_password) && (this.password.trim() !== this.confirm_password.trim()) ){
                this.notify(this.$t('pass_not_match'), 'red', 10);
                return false;
            }

            this.$vs.loading();
            let that = this;
            this.$api({
                method: 'put',
                url: '/auth/password/change',
                data: {
                    token: this.$user.usertoken,
                    username: this.$user.username,
                    password: this.password,
                    confirm_password: this.confirm_password,
                    lang: this.lang,
                }
            }).then(function (response) {
                that.notify('Password alterada', 'green');
                that.logout();
            }).catch(function (error) {
                if (error.response) {
                    let fields = [];
                    
                    if(error.response.data.fields){
                        let obj = error.response.data.fields;
                        let pass = obj.password;
                        for (let i = 0; i < pass.length; i++) {
                            that.notify(pass[i], 'red', 12);
                        }
                    }else if(error.response.data.message){
                        that.notify(error.response.data.message, 'red', 8);
                    }else{
                        that.notify('Error', 'red');
                    }
                } else {
                  that.notify("An unknown error has occured", 'red', 10);
                }
            }).then(function (response) {
                that.$vs.loading.close();
            });
            
        },
    },
    computed: {
        
    },
    created() {
        this.lang = this.$i18n.locale;
        this.updateLocale(this.lang);
        //this.reset_pass();
    },
    watch: {
        '$i18n.locale': function(new_value, old_val) {
            this.lang = new_value;
            this.updateLocale(this.lang);
        }
    }
}
</script>
<style lang="css">
    .hand {
        cursor: pointer;
    }
</style>